import styled from 'styled-components';
import { withTheme } from '@material-ui/core';

export const StyledDate = withTheme(styled('span')`
  color: ${({ theme }) => theme.palette.grey['700']};
`);
